<!-- BIG MODE (SIDEBAR) -->
<div *ngIf="mode=='big'" [ngClass]="documentManagerExpanded ? 'grid grid-2x grid-gap-20' : ''">
  <!-- Loading -->
  <div *ngIf="!isReady">
    <nz-skeleton *ngFor="let item of [1,2,1]" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!isReady">
    </nz-skeleton>
  </div>
  <!-- Loaded -->
  <div *ngIf="isReady" [ngClass]="{'inputs-are-disabled-xx': readonly}">

    <!-- New Requirement Generation -->
    <div class="text-a-right p-b-10 m-t-neg-10" *ngIf="!readonly && !userIsExternal && RequirementEntityGuid">
      <button nz-button [nzType]="'default'" (click)="modalNewRequirement=true" translate [disabled]="unsavedNewRequirement">
        <i nz-icon nzType="plus"  nzTheme="outline"></i> New Requirement
      </button>
    </div>
    <!-- -->

    <!-- ZERO STATE -->
    <div *ngIf="documentCollection.length==0">
      <app-generic-zero-ui
        [list]="[]"
        [title]="docManZeroState.title" [message]="docManZeroState.message" [icon]="docManZeroState.icon"></app-generic-zero-ui>
    </div>

    <!-- Alert on Data change (Repeated 2x) -->
    <div class="p-0" *ngIf="dataChanged">
      <p class="p-10 bg-yellow-light d-b p-l-r-10">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i> Please save document changes.
        <span class="d-b p-t-10"><button nz-button nzType="primary" nzSize="small" (click)="saveReqsAndDocs()">Save</button></span>
      </p>
    </div>

    <!-- HAS DATA ? -->
    <nz-collapse>
      <!-- Documents Loop -->
      <nz-collapse-panel *ngFor="let dc of documentCollection; let i=index;"
       [nzHeader]="sanitizeName(dc.requirements.requirementCd, dc.documents.length, dc.requirements.clientRefGuid)"
       [nzActive]="i==tabIndex"
       [ngClass]="{ 'd-0 d-0-force': hideForExternalUser(dc.requirements) }"
      >
        <!--
        [nzHeader]="sanitizeName(dc.requirements.appliesToCd)=='System'?
        sanitizeName(dc.requirements.requirementCd) :
        sanitizeName(dc.requirements.requirementCd) + ' (' + sanitizeName(dc.requirements.appliesToCd) + ')'"
        -->
        <div *ngIf="dc.requirements.requirementCd!=looseDocsKey" [ngClass]="{'inputs-are-disabled': hideForExternalUser(dc.requirements) }">
          <!-- REQUIREMENT ? -->
          <ng-template #requirementsTmpl>
            <div *ngIf="dc.requirements">
              <p>Status: {{sanitizeName(dc.requirements.status)}}</p>
              <p>Identified By: {{sanitizeName(dc.requirements.identifiedBy)}}</p>
            </div>
          </ng-template>
          <p *ngIf="dc.requirements"
            nz-popover [nzTitle]="sanitizeName(dc.requirements.requirementCd)" [nzContent]="requirementsTmpl" nzPlacement="leftTop" class="p-5 bg-yellow-light d-b">
            Requirement ({{sanitizeName(dc.requirements.appliesToCd)}}) &bull;
            <span>Mandatory: {{dc.requirements.mandatoryFl?sanitizeName(dc.requirements.mandatoryFl):'-'}}</span>
          </p>


          <!-- Editable Fields -->
          <div *ngIf="!readonly">

            <!-- Nominee -->
            <div *ngIf="clientGuidToBeShown(dc.requirements.requirementCd)" class="inputs-are-disabled">
              <h4 class="d-b m-t-10"><i nz-icon nzType="user" nzTheme="outline"></i> Nominee</h4>
              <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select" [(ngModel)]="dc.requirements.clientRefGuid" [nzDisabled]="false">
                <nz-option *ngFor="let u of ioNominees;" [nzLabel]="u.name" [nzValue]="u.guid">
                </nz-option>
              </nz-select>
            </div>

            <!-- Visibility and Status -->
            <div class="flexie-auto-grid">
              <div style="max-width: 50%">
                <h4 class="d-b m-t-10">Status</h4>
                <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select status" [(ngModel)]="dc.requirements.status" (ngModelChange)="dataHasChanged()">
                  <nz-option *ngFor="let item of (lookup$.requirementStatusCd | async); trackBy:item?.lookupKey"
                             [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
              </div>
              <div style="max-width: 50%"> <!-- Width fix-->
                <div> <!-- *ngIf="dc.documents.length>0" MUST CHECK LENGTH (as it's saved to doc, not req) -->
                  <h4 class="d-b m-t-10">Visibility</h4>
                  <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select visibility" [(ngModel)]="dc.requirements.visibilityCd" (ngModelChange)="dataHasChanged()"
                             [nzDisabled]="userIsExternal"
                  > <!--  [(ngModel)]="dc.documents[0].visibilityCd" (ngModelChange)="updateVisibility(dc.documents[0].documentTypeCd,dc.documents[0].documentSubTypeCd,dc.documents[0].visibilityCd)" -->
                    <nz-option *ngFor="let item of (lookup$.docVisibilityCd | async); trackBy:item?.lookupKey"
                               [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
            <div class="flexie-auto-grid">
              <div style="max-width: 50%">
                <h4 class="d-b m-t-10"><!--Received -->Date</h4>
                <nz-date-picker [nzShowTime]="false" style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" [(ngModel)]="dateArray[i]" (ngModelChange)="dateChange(dateArray[i],i)"
                [nzDisabledDate]="disabledDate">
                </nz-date-picker>
              </div>
              <div style="max-width: 50%"> <!-- Width fix-->
                <div *ngIf="isWaived(dc.requirements.status)">
                  <h4 class="d-b m-t-10">Waived Off Reason</h4>
                  <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select reason" [(ngModel)]="dc.requirements.waviedOffReasonCd" (ngModelChange)="dataHasChanged()">
                    <nz-option *ngFor="let item of (lookup$.waivedOffReasonCd | async); trackBy:item?.lookupKey"
                               [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
            <!-- REMARKS -->
            <div>
              <!-- WAIVED Check is hardcoded best-guess as no additional inputs were provided on handling this -->
              <nz-alert *ngIf="isWaived(dc.requirements.status) && (!dc.requirements.remarks || !dc.requirements.waviedOffReasonCd)"
                        class="d-b m-b-5 m-t-10" nzBanner [nzMessage]="'Please specify reason & remarks for waiving off this document'">
              </nz-alert>
              <h4 class="d-b m-t-10">Remarks</h4>
              <textarea class="w-100-pc" rows="2" nz-input placeholder="Comments" [(ngModel)]="dc.requirements.remarks" (ngModelChange)="dataHasChanged()"></textarea>
            </div>
          </div>

          <!-- Selection of Type -- >
          <div class="flex flex-horiz-space-bw p-b-10">
            <div>
              <nz-select nzShowSearch  [nzDisabled]="dc.requirements" [ngModel]="'0'">
                <nz-option [nzLabel]="sanitizeName(dc.requirements.requirementCd)" [nzValue]="'0'"></nz-option>
                <nz-option [nzLabel]="'Additional Proof'" [nzValue]="'Email'"></nz-option>
              </nz-select>
            </div>
            <span>
              <button [disabled]="dc.requirements" nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove section & documents?" nzOkText="Remove" nzCancelText="Cancel" (nzOnConfirm)="removeUploadRow()"><i class="anticon anticon-delete"></i></button>
            </span>
          </div>
          <!.-- Upload -->
          <h4 class="d-b m-t-20 m-b-0-force">Upload new document</h4>
          <nz-upload
            [nzLimit]="1"
            [nzRemove]="fileRemove"
            [(nzFileList)]="dc.UiFilesList"
            [nzBeforeUpload]="fileUploadBefore"
            *ngIf="!readonly"
          >
            <!--
            nzMultiple
            class="upload-list-inline" nzListType="picture"
            [nzCustomRequest]="customXHRReq"
            [nzAction]="fileUploadEndpoint"
            nzAction="https://jsonplaceholder.typicode.com/posts/"
            [nzCustomRequest]="customXHRReq" || [nzCustomRequest]="customHugeXHRReq"
            -->
            <button nz-button (click)="setUploadParams(dc.requirements,i)" class="m-t-10 d-i-b">
              <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
            </button>
          </nz-upload>

          <!-- COMMON -->
          <div class="files-list"><!-- *ngIf="dc.documents.length>0" removed for setting DocumentDO params -->
            <!-- Document List -->
            <div *ngIf="dc.documents.length>0">
            <ng-container *ngFor="let file of dc.documents; let ind=index;">
              <div
                [ngClass]="{ 'd-0 d-0-force case-files': userIsExternal && file.visibilityCd=='INTERNAL' }"
              >
              <div class="files-list-item">
                <!-- Preview -->
                <a (click)="fetchFile(file.imageURL,'preview')" nz-tooltip [nzTitle]="'Preview ' + guessFileType(file.imageURL)" nzPlacement="right">
                  <!-- Icon -->
                  <ng-container [ngSwitch]="guessFileType(file.imageURL)">
                    <i *ngSwitchCase="'Image'" nz-icon nzType="picture" nzTheme="outline"></i>
                    <i *ngSwitchCase="'Video'" nz-icon nzType="video-camera" nzTheme="outline"></i>
                    <i *ngSwitchCase="'Audio'" nz-icon nzType="audio" nzTheme="outline"></i>
                    <i *ngSwitchCase="'Document'" nz-icon nzType="file-pdf" nzTheme="outline"></i>
                    <i *ngSwitchCase="'Sheet'" nz-icon nzType="file-excel" nzTheme="outline"></i>
                    <i *ngSwitchCase="'Archive'" nz-icon nzType="file-zip" nzTheme="outline"></i>
                    <i *ngSwitchCase="'HTML'" nz-icon nzType="file" nzTheme="outline"></i>
                    <i *ngSwitchDefault nz-icon nzType="file" nzTheme="outline"></i>
                  </ng-container>
                  &nbsp;{{guessOriginalFileName(file)}} <!-- WAS: guessFileName(file.imageURL) -->
                </a>
                <!-- Download -->
                <!-- <span *ngIf="enableDownload" class="clickable" (click)="fetchFile(file.imageURL,'download')" nz-tooltip [nzTitle]="'Download ' + guessFileType(file.imageURL)" nzPlacement="left">
                    <i nz-icon nzType="download" nzTheme="outline"></i>
                </span> -->

                <button nz-button nz-dropdown [nzDropdownMenu]="actionsMenu">
                  Actions
                  <i nz-icon nzType="down"></i>
                </button>
                <nz-dropdown-menu #actionsMenu="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    <li *ngIf="appMetadataHandler.featureFlags.enableSplitPreview" nz-menu-item (click)="viewDocumentInSplitMode(file.imageURL);">
                      <span>
                        <i nz-icon nzType="pic-right" nzTheme="outline" class="m-l-5"></i>Split Mode Preview
                      </span>
                    </li>
                    <li nz-menu-item class="clickable" (click)="fetchFile(file.imageURL,'download')">
                      <span>
                        <i nz-icon nzType="download" nzTheme="outline" class="m-l-5"></i>Download
                    </span>
                    </li>
                    <!-- <li nz-menu-item *ngIf="enableDownload && enabledDeleteDocumentBtn() && !checkUser()" class="clickable" (click)="deleteFile(file)">
                      <span>
                        <i nz-icon nzType="delete" nzTheme="outline" class="m-l-5"></i>Delete
                      </span>
                    </li> -->
                  </ul>
                </nz-dropdown-menu>
            </div>
            <div *ngIf="verificationMap[file.guid]">
              <span>Verification Result:</span><span *ngIf="verificationMap[file.guid] && verificationMap[file.guid]['docValidityOutput'] && verificationMap[file.guid]['docValidityOutput']['status']" [ngClass]="{'col-green':verificationMap[file.guid]['docValidityOutput']['status'].finalStatus =='Pass', 'col-red':verificationMap[file.guid]['docValidityOutput']['status'].finalStatus !='Pass'}"> 
                {{verificationMap[file.guid]['docValidityOutput']['status'].finalStatus}}</span>
                <span class="m-l-10"><i nz-icon nzType="exclamation-circle" nzTheme="outline" nz-popover nzPopoverTitle="Rules Executed" [nzPopoverContent]="contentTemplate"></i></span>
                <ng-template #contentTemplate>
                  <div *ngIf="verificationMap[file.guid]['docValidityOutput']['data'] && verificationMap[file.guid]['docValidityOutput']['data'].length>0">
                    <ul>
                        <li *ngFor="let rule of verificationMap[file.guid]['docValidityOutput']['data']">
                          <a>{{rule.validationMsg || rule.ruleName}}</a>
                          <span class="m-l-10">{{(rule.validationStatus == 'true' || rule.validationStatus == true) ? 'Pass' : 'Fail' }}</span>
                        </li>
                    </ul>
                    <li></li>
                  </div>
                </ng-template>
            </div>
              <!-- Per-file META -->
              <div class="grid grid-2x grid-gap-0 p-t-15" style="align-items: center">
                  <!-- VIS -->
                  <h4 class="d-b">Visibility</h4>
                  <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select visibility" [(ngModel)]="file.visibilityCd" (ngModelChange)="dataHasChanged()" nzSize="small"
                           [nzDisabled]="userIsExternal"
                  > <!-- (ngModelChange)="updateVisibility(dc.documents[0].documentTypeCd,dc.documents[0].documentSubTypeCd,dc.documents[0].visibilityCd)"-->
                    <nz-option *ngFor="let item of (lookup$.docVisibilityCd | async); trackBy:item?.lookupKey"
                               [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                  </nz-select>
                  <!-- OTHERS -->
              </div>
              </div>
            </ng-container>
            </div>
          </div>
          <!-- /COMMON -->

          <!-- unused for now
          <h4 class="d-b m-t-10">Requested Date</h4>
          <nz-date-picker nzShowTime style="width:100%"></nz-date-picker>
          <h4 class="d-b m-t-10">Received Date</h4>
          <nz-date-picker nzShowTime style="width:100%"></nz-date-picker>
          <h4 class="d-b m-t-10">Comments</h4>
          <textarea class="w-100-pc" rows="2" nz-input placeholder="Comments"></textarea>
          -->
        </div>

        <!-- ======================== -->
        <!--       LOOSE DOCS         -->
        <!-- ======================== -->
        <div *ngIf="dc.requirements.requirementCd==looseDocsKey" class="loose-docs__xtra"
          [ngClass]="{'inputs-are-disabled case-files': userIsExternal && dc.documents.length>0 && dc.documents[0].visibilityCd=='INTERNAL'}"
        >

          <!-- Secondary loop for LOOSE_DOCS -->
          <div *ngFor="let dc of documentCollectionLoose;let indexParent=index;" class="b-b-1 p-b-20 m-b-25">

            <h1 class="p-b-5 m-b-5 b-b-1">
              <i nz-icon nzType="upload" class="anticon anticon-file-protect"></i>&nbsp;
              {{sanitizeName(dc.requirements.requirementCd)}} - {{sanitizeName(dc.requirements.appliesToCd)}}
            </h1>

            <nz-upload
              [nzLimit]="1"
              [nzRemove]="fileRemove"
              [(nzFileList)]="dc.UiFilesList"
              [nzBeforeUpload]="fileUploadBefore"
              *ngIf="!readonly"
            >
              <button nz-button (click)="setUploadParams(dc.requirements,i)" class="m-t-10 d-i-b"> <!-- `i` is parent loop's index -->
                <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
              </button>
            </nz-upload>

            <!-- COMMON -->
            <div class="files-list" *ngIf="dc.documents.length>0">
              <!-- Document List -->
              <div *ngFor="let file of dc.documents; let ind=index;" class="files-list-item">
                <!-- Preview -->
                <a (click)="fetchFile(file.imageURL,'preview')" nz-tooltip [nzTitle]="'Preview ' + guessFileType(file.imageURL)" nzPlacement="right">
                  <!-- Icon -->
                  <ng-container [ngSwitch]="guessFileType(file.imageURL)">
                    <i *ngSwitchCase="'Image'" nz-icon type="picture" theme="outline"></i>
                    <i *ngSwitchCase="'Video'" nz-icon type="video-camera" theme="outline"></i>
                    <i *ngSwitchCase="'Audio'" nz-icon type="audio" theme="outline"></i>
                    <i *ngSwitchCase="'Document'" nz-icon type="file-pdf" theme="outline"></i>
                    <i *ngSwitchCase="'Sheet'" nz-icon type="file-excel" theme="outline"></i>
                    <i *ngSwitchCase="'Archive'" nz-icon type="file-zip" theme="outline"></i>
                    <i *ngSwitchDefault nz-icon type="file" theme="outline"></i>
                  </ng-container>
                  &nbsp;{{guessOriginalFileName(file)}}
                </a>
                <!-- Download -->
                <span *ngIf="enableDownload" class="clickable" (click)="fetchFile(file.imageURL,'download')" nz-tooltip [nzTitle]="'Download ' + guessFileType(file.imageURL)" nzPlacement="left">
                    <i nz-icon nzType="download" nzTheme="outline"></i>
                </span>
              </div>
              <!-- Editable Fields -->
              <div *ngIf="!readonly">
                <!-- Visibility and Status -->
                <div class="flexie-auto-grid">
                  <div>
                    <h4 class="d-b m-t-10">Visibility</h4>
                    <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select visibility" [(ngModel)]="dc.documents[0].visibilityCd" (ngModelChange)="updateVisibility(dc.documents[0].documentTypeCd,dc.documents[0].documentSubTypeCd,dc.documents[0].visibilityCd)"
                               [nzDisabled]="userIsExternal"
                    >
                      <nz-option *ngFor="let item of (lookup$.docVisibilityCd | async); trackBy:item?.lookupKey"
                                 [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"
                      ></nz-option>
                    </nz-select>
                  </div>
                  <div>
                    <h4 class="d-b m-t-10">Status</h4>
                    <nz-select nzShowSearch  class="w-100-pc" [(ngModel)]="dc.documents[0].documentStatusCd" (ngModelChange)="updateStatus(dc.documents[0].documentTypeCd,dc.documents[0].documentSubTypeCd,dc.documents[0].documentStatusCd)">
                      <nz-option *ngFor="let item of (lookup$.requirementStatusCd | async); trackBy:item?.lookupKey"
                                 [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                  </div>
                </div>
                <!-- Rx.  Date -->
                <div class="flexie-auto-grid">
                  <div style="max-width: 50%" *ngIf="dc.documents">
                    <h4 class="d-b m-t-10"><!--Received -->Date</h4>
                    <nz-date-picker [nzShowTime]="false" style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" [(ngModel)]="dateArrayLoose[indexParent]" (ngModelChange)="updateDate(dc.documents[0].documentTypeCd,dc.documents[0].documentSubTypeCd,dateArrayLoose[indexParent])" [nzDisabledDate]="disabledDate">
                    </nz-date-picker>
                  </div>
                </div>
                <!-- -->
                <!-- Show 'remarks' for FIRST file of a list (it is attached to first file as remarks are attached to document and not requirements, and we show it only once per section -->
                <div *ngFor="let file of dc.documents; let ind=index;">
                  <div *ngIf="0==ind">
                    <h4 class="d-b m-t-10">Remarks</h4>
                    <textarea class="w-100-pc" rows="2" [(ngModel)]="dc.documents[0].remarks" nz-input placeholder="Comments"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <!-- /COMMON -->

          </div>

          <!-- Add new ROW -->
          <div class="bg-grey-e9 p-10 m-t-neg-5" *ngIf="!readonly">
            <h4 class="d-b p-b-20"><i nz-icon nzType="plus" class="anticon anticon-plus"></i> Add new document set</h4>
            <div class="flexie-auto-grid">
              <div style="max-width: 75%">
                <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select type" [(ngModel)]="looseDocNewType" >
                  <nz-option *ngFor="let item of (lookup$.documentCd | async); trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
              </div>
              <div>
                <button nz-button (click)="addUploadRowCustomReqLooseDec(looseDocsKey,looseDocNewType)">Add Row</button>
              </div>
            </div>
          </div>

        </div><!-- /loose-docs -->

      </nz-collapse-panel>
    </nz-collapse>

    <!-- Alert on Data change (Repeated 2x) -->
    <div class="p-t-20 p-b-0 m-b-0" *ngIf="dataChanged">
      <p class="p-10 bg-yellow-light d-b">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i> Please save document changes.
        <span class="d-b p-t-10"><button nz-button nzType="primary" nzSize="small" (click)="saveReqsAndDocs()">Save</button></span>
      </p>
    </div>
  <div>
    <div *ngIf="modalFilePreview && documentManagerExpanded">
      <div class="flex flex-both-center flex-dir-vert text-a-center">
  
        <!-- Show Loading if file is being downloaded -->
        <div *ngIf="fileIsBeingDownloaded" class="col-grey-light">
          <span style="display:block;padding:30px 0">
            Fetching file... please wait
          </span>
          <nz-spin [nzSpinning]="true"></nz-spin>
        </div>
  
        <!-- No Data stream? Not previewable -->
        <div *ngIf="!fileIsBeingDownloaded && !previewDataStream">
          <h3 class="f-s-1-2r">{{guessFileType(previewFileUrl)}}</h3>
          <span>{{notSupportedText}}</span>
        </div>
  
        <!-- Special Case: Container el. for rendering decoded TIFF -->
        <div id="tiff-canvas" *ngIf="modalFilePreview"></div>
  
        <!-- Data Stream Exists? (&& modalFilePreview -> to stop video/audio on close of modal) -->
        <div *ngIf="!!previewDataStream && modalFilePreview">
  
          <ng-container [ngSwitch]="guessFileType(previewFileUrl)">
  
            <!-- Image Preview -->
            <div *ngSwitchCase="'Image'">
              <!-- TIFF -->
              <!-- -->
              <!-- Others -->
              <img [src]="previewDataStream" alt="" />
            </div>
  
  
            <!-- Video Preview -->
            <video controls autoplay loop *ngSwitchCase="'Video'" width="640" height="480" controlsList="nodownload">
              <source [src]="previewDataStream" type="video/mp4">
              Your browser does not support the <code>video</code> element.
            </video>
  
            <!-- Audio Preview -->
            <audio autoplay controls loop *ngSwitchCase="'Audio'" [src]="previewDataStream" controlsList="nodownload">
              Your browser does not support the <code>audio</code> element.
            </audio>
  
            <!-- PDF -->
            <div *ngSwitchCase="'Document'">
              <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:640px">
              </pdf-viewer>
            </div>
  
            <!-- HTML -->
            <div *ngSwitchCase="'HTML'" class="w-100-pc">
              <div [innerHTML]="previewDataStream"></div>
            </div>
  
          </ng-container>
        </div>
  
        <!-- OCR Verification -->
        <!-- Show iff everything is Okay -->
        <!-- <div *ngIf="OCRReady && OCRverificationData && modalFilePreview
                      && !!previewDataStream && previewDataStreamUnsanitized
                      && ('Image'==guessFileType(previewFileUrl))">
          <br />
          <app-ocr-verifier [imageData]="previewDataStreamUnsanitized"
            [verificationArr]="OCRverificationData"></app-ocr-verifier>
        </div> -->
        <!-- / OCR Verification -->
  
  
        <!-- Link to Download -->
        <div *ngIf="enableDownload || !fileIsPreviewable(previewFileUrl)">
          <button nz-button nzType="primary" class="m-t-20"
            (click)="fetchFile(previewFileUrl,'download')">Download</button>
        </div>
  
      </div>
    </div>
    <div *ngIf="!modalFilePreview && documentManagerExpanded">
      <app-generic-zero-ui title="Preview" message="Image preview will be visible here." icon="exclamation-circle"
        [list]="[]"></app-generic-zero-ui>
    </div>
  </div>
</div>
</div>

<!-- MINI/SMALL MODE (INDIVIDUAL COMPONENTS)-->
<div *ngIf="(mode=='mini' || mode=='small') && documentCollectionMiniMode.length">

  <!-- CHEQUE UPLOAD AND VERIFICATION -->

  <div class="heading-tab">
    <h3 class="heading" *ngIf="headingType=='heading'">{{heading}}</h3>
    <label class="d-b" *ngIf="headingType=='label'">{{heading}}</label>
  </div>

  <!-- Upload for MINI MODE -->
  <div *ngFor="let dc of documentCollectionMiniMode | slice:0:1; let i = index;">
    <nz-upload
      [nzLimit]="1"
      [nzRemove]="fileRemove"
      [(nzFileList)]="dc.UiFilesList"
      [nzBeforeUpload]="fileUploadBefore"
      [nzShowButton]="dc.UiFilesList.length < 1"
      *ngIf="!readonly"
    >
      <button nz-button (click)="setUploadParams(dc.requirements,0, clientRefGuid)" class="m-t-10 d-i-b">
        <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
      </button>
    </nz-upload>
    <!-- Document List -->
    <div class="files-list" *ngIf="dc.documents.length>0">
      <div *ngFor="let file of dc.documents" class="files-list-item">
        <!-- Preview -->
        <a (click)="fetchFile(file.imageURL,'preview')" nz-tooltip [nzTitle]="'Preview ' + guessFileType(file.imageURL)" nzPlacement="right">
          <!-- Icon -->
          <ng-container [ngSwitch]="guessFileType(file.imageURL)">
            <i *ngSwitchCase="'Image'" nz-icon nzType="picture" nzTheme="outline"></i>
            <i *ngSwitchCase="'Video'" nz-icon nzType="video-camera" nzTheme="outline"></i>
            <i *ngSwitchCase="'Audio'" nz-icon nzType="audio" nzTheme="outline"></i>
            <i *ngSwitchCase="'Document'" nz-icon nzType="file-pdf" nzTheme="outline"></i>
            <i *ngSwitchCase="'Sheet'" nz-icon nzType="file-excel" nzTheme="outline"></i>
            <i *ngSwitchCase="'Archive'" nz-icon nzType="file-zip" nzTheme="outline"></i>
            <i *ngSwitchDefault nz-icon nzType="file" nzTheme="outline"></i>
          </ng-container>
          &nbsp;{{guessOriginalFileName(file)}}
        </a>
        <!-- Download -->
        <span *ngIf="enableDownload" class="clickable" (click)="fetchFile(file.imageURL,'download')" nz-tooltip [nzTitle]="'Download ' + guessFileType(file.imageURL)" nzPlacement="left">
            <i nz-icon nzType="download" nzTheme="outline"></i>
        </span>
      </div>
    </div>

  </div>

<!-- OCR Verification -- >
<div *ngIf="OCRReady && OCRverificationData && OCRfileImage">
  <app-ocr-verifier [imageData]="OCRfileImage" [verificationArr]="OCRverificationData"></app-ocr-verifier>
</div>
<.!-- / OCR Verification -->

</div>

<!-- COMMONS -->
<nz-modal [(nzVisible)]="modalFilePreview && !documentManagerExpanded"
          [nzFooter]="null"
          [nzMaskClosable]="false"
          nzWidth="640px"
          [nzTitle]=" guessOriginalFileNameFromImgURL(previewFileUrl) + ' preview'"
          (nzOnCancel)="modalFilePreview=false" (nzOnOk)="modalFilePreview=false"
>
<ng-container *nzModalContent>
  <div class="flex flex-both-center flex-dir-vert text-a-center">

    <!-- Show Loading if file is being downloaded -->
    <div *ngIf="fileIsBeingDownloaded" class="col-grey-light">
                <span style="display:block;padding:30px 0">
                  Fetching file... please wait
                </span>
      <nz-spin [nzSpinning]="true"></nz-spin>
    </div>

    <!-- No Data stream? Not previewable -->
    <div *ngIf="!fileIsBeingDownloaded && !previewDataStream">
      <h3 class="f-s-1-2r">{{guessFileType(previewFileUrl)}}</h3>
      <span>{{notSupportedText}}</span>
    </div>

    <!-- Special Case: Container el. for rendering decoded TIFF -->
    <div id="tiff-canvas" *ngIf="modalFilePreview"></div>

    <!-- Data Stream Exists? (&& modalFilePreview -> to stop video/audio on close of modal) -->
    <div *ngIf="!!previewDataStream && modalFilePreview">

      <ng-container [ngSwitch]="guessFileType(previewFileUrl)">

        <!-- Image Preview -->
        <div *ngSwitchCase="'Image'">
          <!-- TIFF -->
            <!-- -->
          <!-- Others -->
          <img [src]="previewDataStream" alt="" />
        </div>


        <!-- Video Preview -->
        <video controls autoplay loop *ngSwitchCase="'Video'" width="640" height="480" controlsList="nodownload">
          <source [src]="previewDataStream" type="video/mp4">
          Your browser does not support the <code>video</code> element.
        </video>

        <!-- Audio Preview -->
        <audio autoplay controls loop *ngSwitchCase="'Audio'" [src]="previewDataStream" controlsList="nodownload">
          Your browser does not support the <code>audio</code> element.
        </audio>

        <!-- PDF -->
        <div *ngSwitchCase="'Document'">
          <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:640px">
          </pdf-viewer>
        </div>

        <!-- HTML -->
        <div *ngSwitchCase="'HTML'" class="w-100-pc">
          <div [innerHTML]="previewDataStream"></div>
        </div>

      </ng-container>
    </div>

    <!-- OCR Verification -->
    <!-- Show iff everything is Okay -->
    <div *ngIf="OCRReady && OCRverificationData && modalFilePreview
                && !!previewDataStream && previewDataStreamUnsanitized
                && ('Image'==guessFileType(previewFileUrl))"
    >
      <br/>
      <app-ocr-verifier [imageData]="previewDataStreamUnsanitized" [verificationArr]="OCRverificationData"></app-ocr-verifier>
    </div>
    <!-- / OCR Verification -->


    <!-- Link to Download -->
    <div *ngIf="enableDownload || !fileIsPreviewable(previewFileUrl)">
      <button nz-button nzType="primary" class="m-t-20"
              (click)="fetchFile(previewFileUrl,'download')">Download</button>
    </div>

  </div>
  </ng-container>
</nz-modal>

<!-- NEW REQUIREMENT MODAL -->
<nz-modal [(nzVisible)]="modalNewRequirement"
          [nzFooter]="null"
          [nzMaskClosable]="true"
          nzWidth="640px"
          [nzTitle]="'New Requirement'"
          (nzOnCancel)="modalNewRequirement=false" (nzOnOk)="modalNewRequirement=false"
>
<ng-container *nzModalContent>
  <div class="grid grid-gap-20 grid-2x grid-2x-responsove p-b-20">

    <div>
      <h4 class="d-b m-t-10">Requirement</h4>
      <nz-select nzShowSearch  [(ngModel)]="newReqTemp.userRequirement" style="width:100%;max-width: 292px">
        <nz-option *ngFor="let ur of lookupUserRequirements" [nzLabel]="ur.lookupValue" [nzValue]="ur.lookupKey"></nz-option>
      </nz-select>
    </div>

    <!-- Nominee (conditional) -->
    <div *ngIf="isNomineeRelated(newReqTemp.userRequirement)">
      <h4 class="d-b m-t-10"><i nz-icon nzType="user" nzTheme="outline"></i> Nominee</h4>
      <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select" [(ngModel)]="newReqTemp.clientRefGuid" [nzDisabled]="false">
        <nz-option *ngFor="let u of ioNominees;" [nzLabel]="u.name" [nzValue]="u.guid">
        </nz-option>
      </nz-select>
    </div>

    <!-- Client (conditional) -->
    <div *ngIf="isClientRelated(newReqTemp.userRequirement)">
      <h4 class="d-b m-t-10"><i nz-icon nzType="user" nzTheme="outline"></i> Client</h4>
      <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select" [(ngModel)]="newReqTemp.clientRefGuid" [nzDisabled]="false">
        <nz-option *ngFor="let u of ioClients;" [nzLabel]="u.name" [nzValue]="u.guid">
        </nz-option>
      </nz-select>
    </div>

    <!--<div>
      <h4 class="d-b m-t-10">Status</h4>
      <nz-select nzShowSearch  [(ngModel)]="newReqTemp.statusCd" style="width:100%;">
        <nz-option *ngFor="let item of (lookup$.requirementStatusCd | async); trackBy:item?.lookupKey"
           [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
      </nz-select>
    </div>

    <div>
      <h4 class="d-b m-t-10">Identified Date</h4>
      <nz-date-picker name="date" [(ngModel)]="newReqTemp.identifedDt"></nz-date-picker>
    </div>-->

    <div>
      <h4 class="d-b m-t-10">Resolve by stage</h4>
      <nz-select nzShowSearch  [(ngModel)]="newReqTemp.resolveByStageCd" style="width:100%;max-width: 292px">
        <nz-option *ngFor="let item of (lookup$.NBUResolveByStageCd | async); trackBy:item?.lookupKey"
                   [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
      </nz-select>
    </div>

    <!--<div>
      <h4 class="d-b m-t-10">Requested Date</h4>
      <nz-date-picker name="date" [(ngModel)]="newReqTemp.requestedDt"></nz-date-picker>
    </div>-->

  </div>

  <!-- Remarks -->
  <h4 class="d-b m-t-10">Remarks</h4>
  <textarea rows="2" nz-input [(ngModel)]="newReqTemp.remarks"></textarea>

  <!-- Comment in cases of "OTHERS" requirementCd -->
  <div *ngIf="newReqTemp.userRequirement=='OTHER' || newReqTemp.userRequirement=='OTHERS'">
    <h4 class="d-b m-t-20">Special Comments</h4>
    <textarea rows="2" nz-input [(ngModel)]="newReqTemp.orderingNotes"></textarea>
  </div>

  <div class="d-b p-t-5">
    <button nz-button nzType="primary" (click)="createNewReq()" class="d-b">Create Requirement</button>
  </div>
</ng-container>

</nz-modal>

<!-- DEBUG -->
<div *ngIf="!isProd && 1" class="p-20 p-b-0">
  <!--<button nz-button (click)="addUploadRowLooseDocs()" class="d-b m-t-20">Add More</button>-->
  <!-- <div *ngFor="let item of (lookup$['documentTypeCd'] || [] | async) as documentTypeCd;">
     {{item?.lookupKey}}
   </div>-->
  <!--<div *ngFor="let dc of documentCollection; let i = index;">
    {{dc|json}}
  </div>-->

  <!--
  <pre> documentCd {{lookup$.documentCd | async}}</pre>
  <pre> requirementStatusCd {{lookup$.requirementStatusCd | async}}</pre>
  <pre> docVisibilityCd {{lookup$.docVisibilityCd | async}}</pre>-- >

  <pre>DateLooseArray: {{ dateArrayLoose | json }}</pre>
  <br>
  <pre>documentCollection: {{ documentCollection | json }}</pre>
  <br>
  <pre>documentCollectionMiniMode: {{ documentCollectionMiniMode | json }}</pre>
  <br>
  <pre>documentCollectionLoose: {{ documentCollectionLoose | json }}</pre>
  <br>
  <pre>documentListServer: {{ documentsFromServer | json }}</pre>
  <br>
  <pre>MINI MODE</pre>
  <br>
  ClientRefGuid: {{clientRefGuid}}
  <br>
  <pre>clientDO: {{ clientDO | json }}</pre>
  -->
</div>
